// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-o_he","advertDetailParameterList__header":"c-o_hf","advertDetailParameterList__list":"c-o_hg"};